// localStorage daje origin tylko ~5 MB i jest WSPÓŁDZIELONY przez całą aplikację.
// Duże wpisy (np. obrazy tła Biurka zapisywane jako data-URL) potrafią wyczerpać
// tę pulę. Gdy to nastąpi, biblioteka OIDC nie jest w stanie zapisać żetonu/stanu
// logowania i zwraca „Failed to execute 'setItem' on 'Storage': … exceeded the
// quota", przez co nie da się w ogóle zalogować.
//
// Ten store opakowuje window.localStorage tak, by przy przepełnieniu zwolnić
// miejsce — usuwa NAJWIĘKSZE wpisy nieistotne dla uwierzytelnienia i ponawia
// zapis. Klucze auth (oidc.*, user:*, nota.*, klucze szyfrujące profilu) są
// chronione przed usunięciem, więc samonaprawa nigdy nie wyloguje użytkownika.

const AUTH_KEY = /^oidc\.|^user:|^nota\.|\.keys$|\.recov$|\.rk$/;

const isQuotaError = (e: unknown): boolean =>
  e instanceof DOMException &&
  // Standard + warianty starszych przeglądarek (Firefox / Safari).
  (e.name === "QuotaExceededError" ||
    e.name === "NS_ERROR_DOM_QUOTA_REACHED" ||
    e.code === 22 ||
    e.code === 1014);

// Usuwa największe nie-auth wpisy aż zapis `key=value` się powiedzie.
const evictUntilFits = (key: string, value: string): boolean => {
  const candidates: { key: string; size: number }[] = [];
  for (let i = 0; i < window.localStorage.length; i++) {
    const k = window.localStorage.key(i);
    if (!k || k === key || AUTH_KEY.test(k)) continue;
    const v = window.localStorage.getItem(k) ?? "";
    candidates.push({ key: k, size: k.length + v.length });
  }
  candidates.sort((a, b) => b.size - a.size);

  for (const c of candidates) {
    window.localStorage.removeItem(c.key);
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      if (!isQuotaError(e)) throw e;
      // Wciąż za mało miejsca — usuwamy kolejny największy wpis.
    }
  }
  return false;
};

export const resilientLocalStorage = {
  get length() {
    return window.localStorage.length;
  },
  clear() {
    window.localStorage.clear();
  },
  key(index: number) {
    return window.localStorage.key(index);
  },
  getItem(name: string) {
    return window.localStorage.getItem(name);
  },
  removeItem(name: string) {
    window.localStorage.removeItem(name);
  },
  setItem(name: string, value: string) {
    try {
      window.localStorage.setItem(name, value);
    } catch (e) {
      if (!isQuotaError(e)) throw e;
      if (!evictUntilFits(name, value)) throw e; // nie udało się zwolnić miejsca
    }
  },
} as Storage;
